import { parseISO } from "date-fns";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { useSelector } from "react-redux";
import ErrorSummary from "../../components/form_elements/error-summary";

const EmployeeValidation = () => {
    const {setValue, register} = useFormContext();
    const enrollments = useSelector(s => s.enrollments);

    useEffect(() => {
        if(Array.isArray(enrollments)){
            return;
        }
        const employee = enrollments.employee;
        const birthdate = employee?.birthdate ? parseISO(employee?.birthdate): null;

        setValue("firstName", employee?.firstName);
        setValue("lastName", employee?.lastName);
        setValue("ssn", employee?.ssn);
        setValue("birthdate", birthdate);
        setValue("maritalStatusId", employee?.maritalStatus?.id);
        setValue("genderId", employee?.gender?.id);
        setValue("addressLine1", employee?.addressLine1);
        setValue("addressLine2", employee?.addressLine2);
        setValue("city", employee?.city);
        setValue("state", employee?.state);
        setValue("region", employee?.region);
        setValue("postalCode", employee?.postalCode);
        setValue("country", employee?.country);

    }, [enrollments])

    return ( 
        <>
            <input type="hidden" {...register("firstName")}  />
            <input type="hidden" {...register("lastName")}  />
            <input type="hidden" {...register("ssn")}  />
            <input type="hidden" {...register("birthdate")}  />
            <input type="hidden" {...register("maritalStatusId")}  />
            <input type="hidden" {...register("genderId")}  />
            <input type="hidden" {...register("addressLine1")}  />
            <input type="hidden" {...register("city")}  />
            <input type="hidden" {...register("state")}  />
            <input type="hidden" {...register("region")}  />
            <input type="hidden" {...register("postalCode")}  />
            <input type="hidden" {...register("country")}  />
            <ErrorSummary />
        </>
     );
}
 
export default EmployeeValidation;